import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  Chip,
} from '@mui/material';
import { Close, CheckCircle } from '@mui/icons-material';

import { AgencyMonitoringDetailLogsPanel } from './AgencyMonitoringDetailLogsPanel';

interface Agency {
  id: string;
  name: string;
  code: string;
  isMonitored: boolean;
  totalLegislations: number;
}

interface AgencyMonitoringDetailLogsDialogProps {
  open: boolean;
  onClose: () => void;
  agency: Agency | null;
}

export function AgencyMonitoringDetailLogsDialog({
  open,
  onClose,
  agency,
}: AgencyMonitoringDetailLogsDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box>
            <Typography variant="h6" fontWeight={600}>
              LOGs — {agency?.name ?? 'Agência'}
            </Typography>
            {agency && (
              <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                <Chip label={agency.code.toUpperCase()} size="small" color="primary" variant="outlined" />
                {agency.isMonitored && (
                  <Chip label="Ativa" size="small" color="success" icon={<CheckCircle />} />
                )}
              </Box>
            )}
          </Box>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <AgencyMonitoringDetailLogsPanel
          agencyCode={agency?.code ?? null}
          agencyName={agency?.name ?? null}
          enabled={open}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} variant="contained">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
